import * as React from 'react';
import { connect } from 'react-redux';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { POLICY_DETAILS, DASHBOARD, CLAIMS, CLAIM_END_PAGE, FNOL_CLAIM_PROGRESS_MOBILE, FNOL } from '../../routes/routes';
import ClaimCapture from './ClaimCapture';
import { navigateTo } from '../../actions/navigationActions';
import { Image, Button } from 'react-bootstrap';
import { showCallMeModal, showFnolCallMeModal } from '../../actions/modalActions';
import { setStep } from '../../actions/claimSubmitActions';
import ClaimProgress from './ClaimProgress';
import { isMobile } from 'react-device-detect';
import NotifyUsofClaimBlock from './NotifyUsofClaimBlock';
import { CLAIM_TYPE_GLASS, CLAIM_TYPE_CELLPHONE, CLAIM_TYPE_WARRANTY, CLAIM_TYPE_VAP } from '../../constants/constants';
import NeedHelp from '../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';

class SubmitClaim extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleCallMeBack = async (e: any) => {
        this.props.handleCallMeBack();
    }

    handleCoverRedirect() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    public render() {
        const { profile } = this.props;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }]
        let isThisFlowGlassClaims = this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS;
        return (
            <div id="SubmitClaim" className="container-fluid new-page-margins fnol-capture-main-container">
                <div className="new-breadcrumbwrapper breadcrumb-wrapper-fnol-capture-main-actual">
                    {!isMobile &&
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                    }
                    {(((this.props.claimSubmit.selectedClaimStep.step === 1 && this.props.claimSubmit.selectedClaimStep.subStep < 4) || this.props.claimSubmit.selectedClaimStep.title === 'Complete')) && !this.props.claimSubmit.followUp && isMobile &&
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                    }
                    {((this.props.claimSubmit.selectedClaimStep.step === 1 && this.props.claimSubmit.selectedClaimStep.subStep === 4) || (this.props.claimSubmit.selectedClaimStep.step > 1 || this.props.claimSubmit.followUp && this.props.claimSubmit.selectedClaimStep.title !== 'Complete')) && isMobile &&
                        <div className="progress-back" onClick={() => this.handleRedirect(FNOL_CLAIM_PROGRESS_MOBILE)}>
                            <span><img src="./Images/grey-small-breadcrumb-arrow.png" className="pr-2" />Back to my progress</span>
                        </div>
                    }
                </div>
                <div className="row new-page-main-row">
                    {profile.personalPolicies[0] !== undefined &&
                        <>
                            {/*/// DESKTOP VIEW ///*/}
                            <div className="col-12 nopa d-none d-sm-none d-md-none d-lg-block d-xl-block">
                                {(this.props.claimSubmit.selectedClaimStep.step >= 2 || this.props.claimSubmit.selectedClaimStep.subStep > 1) &&
                                <div className="row noma fnol-submitclaim-desktop-main-row">
                                    {(this.props.claimSubmit.selectedClaimStep.step === 1 && this.props.claimSubmit.selectedClaimStep.subStep < 4 && this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS && this.props.claimSubmit.claimType !== CLAIM_TYPE_WARRANTY && this.props.claimSubmit.claimType !== CLAIM_TYPE_VAP && this.props.claimSubmit.claimType !== CLAIM_TYPE_CELLPHONE && !this.props.claimSubmit.followUp) && <div className="col col-notify-claim">
                                            <NotifyUsofClaimBlock />
                                </div>}
                                    {(this.props.claimSubmit.selectedClaimStep.step >= 2 || this.props.claimSubmit.selectedClaimStep.subStep > 3 || this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS || this.props.claimSubmit.claimType === CLAIM_TYPE_WARRANTY || this.props.claimSubmit.claimType === CLAIM_TYPE_VAP || this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE || this.props.claimSubmit.followUp)
                                    && <ClaimProgress />}
                                        <div className="col">
                                            <ClaimCapture />
                                        <div className={"w-100 mt-15px " + (this.props.claimSubmit.selectedClaimStep.step > 1 || this.props.claimSubmit.selectedClaimStep.subStep > 2 || this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE || this.props.claimSubmit.followUp ? 'd-none ' : '') + (isThisFlowGlassClaims === true ? 'd-block glass-claims-needhelp-outercontainer' : '')}>
                                        <NeedHelp
                                            isFnol={true}
                                            countryId={this.props.profile.countryId}
                                            claimsEmail={this.props.ssp.claims_email}
                                            contactUsTel={this.props.ssp.contactUs_tel}
                                            handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                        />
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.props.claimSubmit.selectedClaimStep.subStep === 1 && this.props.claimSubmit.selectedClaimStep.step <= 1 &&
                                    <div className="row noma">
                                        <div className="col col-notify-claim">
                                    {!this.props.claimSubmit.followUp && <NotifyUsofClaimBlock />}
                                    {this.props.claimSubmit.followUp
                                        && <ClaimProgress />}
                                </div>
                                
                                        <div className="col col-fnol-right">
                                            {this.props.claimSubmit.selectedClaimStep.subStep === 1 && <ClaimCapture />}
                                        <div className={"w-100 mt-15px " + (this.props.claimSubmit.selectedClaimStep.step > 1 || (this.props.claimSubmit.selectedClaimStep.subStep > 2 && this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS) || this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE || this.props.claimSubmit.followUp ? 'd-none ' : '') + (isThisFlowGlassClaims === true ? 'd-block glass-claims-needhelp-outercontainer' : '')}>
                                        <NeedHelp
                                            isFnol={true}
                                            countryId={this.props.profile.countryId}
                                            claimsEmail={this.props.ssp.claims_email}
                                            contactUsTel={this.props.ssp.contactUs_tel}
                                            handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                        />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            {/*/// *** *** ///*/}

                            {/*/// MOBILE VIEW ///*/}
                            <div className="col-12 d-block d-sm-block d-md-block d-lg-none d-xl-none nopa">
                                <div className="row noma">
                                {this.props.claimSubmit.selectedClaimStep.step === 1 && this.props.claimSubmit.selectedClaimStep.subStep < 2 && !this.props.claimSubmit.followUp && <div className="col-12 col-notify-claim-nomaxwidth">
                                        <NotifyUsofClaimBlock />
                                    </div>
                                    }
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <ClaimCapture />
                                    </div>
                                </div>
                            <div className={"row " + (this.props.claimSubmit.selectedClaimStep.step > 1 || this.props.claimSubmit.selectedClaimStep.subStep > 2 || this.props.claimSubmit.claimType !== CLAIM_TYPE_CELLPHONE ? 'd-none ' : '') + (isThisFlowGlassClaims === true ? 'd-block glass-claims-needhelp-outercontainer' : '')}>
                                    <div className="col-12">
                                    <NeedHelp
                                        isFnol={true}
                                        countryId={this.props.profile.countryId}
                                        claimsEmail={this.props.ssp.claims_email}
                                        contactUsTel={this.props.ssp.contactUs_tel}
                                        handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                    />
                                    </div>
                                </div>
                            </div>
                            {/*/// *** *** ///*/}
                        </>
                    }
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp:state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showFnolCallMeModal()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitClaim);